import { useEffect } from 'react';
import { createRootRoute, Outlet, useMatches } from '@tanstack/react-router';

export const Route = createRootRoute({
  component: RootLayout,
});

function RootLayout() {
  const matches = useMatches();

  useEffect(() => {
    // Find the deepest matched route with a title in staticData
    for (let i = matches.length - 1; i >= 0; i--) {
      const title = (matches[i].staticData as { title?: string })?.title;
      if (title) {
        document.title = `${title} - Rivaled`;
        return;
      }
    }
    document.title = 'Rivaled';
  }, [matches]);

  return (
    <div className="min-h-screen bg-surface-900 text-white">
      <Outlet />
    </div>
  );
}
